export default "__VITE_ASSET___VdpKdWA__"